var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"app":"","flat":"","color":"primary","dark":""}},[_c('img',{attrs:{"src":require("../assets/Telescope 2.png"),"height":"100%"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }